/* eslint-disable no-unused-vars */
export enum httpRequest {
    GET = 'GET',
    POST = 'POST',
    PATCH = 'PATCH',
    DELETE = 'DELETE',
    PUT = 'PUT',
}
